export default __webpack_public_path__ + "static/media/watchFreeVideos.db3c6cfa.png";